import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'ngx-form-entry',
  templateUrl: './form-entry.component.html',
  styleUrls: ['./form-entry.component.scss'],
})
export class FormEntryComponent implements OnInit {

  @Input() title: string;
  @Input() value: string;
  @Input() email: boolean = false;

  constructor() { }

  ngOnInit() {
  }

}
